import { render, staticRenderFns } from "./MessageBubble.vue?vue&type=template&id=31212c74&scoped=true&"
import script from "./MessageBubble.vue?vue&type=script&lang=js&"
export * from "./MessageBubble.vue?vue&type=script&lang=js&"
import style0 from "./MessageBubble.vue?vue&type=style&index=0&id=31212c74&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31212c74",
  null
  
)

export default component.exports